// extracted by mini-css-extract-plugin
export var boxItems = "_6p-1";
export var boxItemsLg = "_6p-2";
export var button = "_6p-7";
export var buttonLg = "_6p-8";
export var filterGroupBox = "_6p-0";
export var icon = "_6p-3";
export var iconSecondary = "_6p-6";
export var iconWrapper = "_6p-4";
export var iconWrapperLg = "_6p-5";